import { getApiTimelines } from 'reduxes/slices/api/selectors'
import { getCurrentHandle } from 'reduxes/slices/current/selectors'
import { getSelectedTopicId } from 'reduxes/slices/selected/selectors'
import { createSelector } from 'reselect'

import { getTimelinesPaging } from '../paging/selectors'

const getTimelinesForSelectedTopic = createSelector(
  [getSelectedTopicId, getApiTimelines],
  (selectedTopicId, timelines) => {
    return Object.values(timelines).filter(
      (timeline) => timeline.topic_id === selectedTopicId,
    )
  },
)

const emptyArray = []
export const getMatchingTimelines = createSelector(
  [getTimelinesForSelectedTopic, getTimelinesPaging],
  (timelines, { before, cachedBefore }) => {
    const b = before || cachedBefore
    if (b) {
      // ignore timelines older than what has explicitly been fetched, but allow new timelines
      return timelines
        .filter((timeline) => timeline.id >= b)
        .sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at))
    } else {
      return emptyArray
    }
  },
)

export const getMaxTimelineUpdatedAt = createSelector(
  [getTimelinesForSelectedTopic],
  (timelines) => {
    const timestamps = timelines.map(
      (timeline) => new Date(timeline.updated_at),
    )
    return Math.max(...timestamps)
  },
)

export const getMyLatestChatTimeline = createSelector(
  [getTimelinesForSelectedTopic, getCurrentHandle],
  (timelines, currentHandle) => {
    return timelines
      .filter(
        (timeline) =>
          timeline.tl_type === 'Chat' && timeline.handle === currentHandle,
      )
      .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at))[0]
  },
)

export const makeGetLatestChatTimeline = () =>
  createSelector(
    [(_, topicId) => topicId, getApiTimelines],
    (topicId, timelines) => {
      return Object.values(timelines)
        .filter(
          (timeline) =>
            timeline.topic_id === topicId && timeline.tl_type === 'Chat',
        )
        .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at))[0]
    },
  )

export const getReplyTimelineLookup = (state) => state.replyTimelineId

export const getReplyTimeline = createSelector(
  [getSelectedTopicId, getReplyTimelineLookup, getApiTimelines],
  (topicId, lookup, timelines) => {
    const id = lookup[topicId]
    return timelines?.[id]
  },
)

export const makeGetTimeline = () =>
  createSelector([getApiTimelines, (_, id) => id], (timelines, id) => {
    return timelines?.[id]
  })
